import { filesize } from "filesize";

import type { CompressOption } from "./ImageBase";
import { Mimes } from "./mimes";
import type { IFile } from "./queue";

export function splitFileName(fileName: string) {
  const index = fileName.lastIndexOf(".");
  const name = fileName.substring(0, index);
  const suffix = fileName.substring(index + 1).toLowerCase();
  return { name, suffix };
}

/**
 * Get final file name if there exists a type convert
 * @param item
 * @param option
 * @returns
 */
export function getOutputFileName(item: IFile, option: CompressOption) {
  if (item.blob.type === item.compress?.blob.type) {
    return item.name;
  }

  const { name, suffix } = splitFileName(item.name);
  let resultSuffix = suffix;
  for (const key in Mimes) {
    if (item.compress!.blob.type === Mimes[key]) {
      resultSuffix = key;
      break;
    }
  }

  if (["jpg", "jpeg"].includes(resultSuffix)) {
    resultSuffix = option.format.target?.toLowerCase() || resultSuffix;
  }

  return name + "." + resultSuffix;
}

/**
 * Beautify byte size
 * @param num byte size
 * @returns
 */
export function formatSize(num: number) {
  const result = filesize(num, { standard: "jedec", output: "array" });
  return result[0] + " " + result[1];
}

export const getCompressRatio = (originalSize: number, compressedSize: number) => {
  const ratio = 1 - compressedSize / originalSize;
  return (ratio * 100).toFixed(2);
};